export const REQUEST_PROMO_MESSAGE = 'zola/promoMessage/REQUEST_PROMO_MESSAGE';
export const RECEIVE_PROMO_MESSAGE = 'zola/promoMessage/RECEIVE_PROMO_MESSAGE';
